/**
 * Money formatting for the accounting module.
 *
 * Amounts are integer so'm (`number`). `ru-RU` grouping renders "1 234 567"
 * (space-grouped, no fraction) — matches the prototype's display and the
 * Uzbek convention. Currency LABELS are NOT here: they resolve through i18n
 * (`CURRENCY_LABEL_KEY` in model/status-meta.ts), so this stays a pure,
 * locale-agnostic number formatter with zero hardcoded currency words.
 */

const grouper = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

/** "1 234 567" — grouped integer, no sign, no currency. */
export function formatAmount(amount: number): string {
  return grouper.format(amount)
}

/**
 * Signed amount for the net-result / delta displays: "+1 234 567",
 * "−1 234 567" (U+2212 minus), or "0". Pair with a colour decided by the
 * caller (green for positive, red for negative).
 */
export function formatSignedAmount(amount: number): string {
  if (amount === 0) return grouper.format(0)
  const sign = amount > 0 ? '+' : '−'
  return `${sign}${grouper.format(Math.abs(amount))}`
}
